import React from 'react';
import Main from '../components/Main';
import { Wrap } from '../components/styled';
import { ContentTwoModal, getTextMessageTwoModal } from './ContentTwoModal';
import MessagePlate from '../components/MessagePlate';
import { useMunicipalityTasks } from '../MunicipalityTasksContext';
import { getTextPlate } from '../getText';

export const FunctionalLiteracy = () => {
  const { values, id, userType } = useMunicipalityTasks();
  const { plate1, plate2, plate3, plate4 } = values;
  const isDone = plate1?.status! && plate2?.status! && plate3?.status! && plate4?.status!;

  const textPlate2 = getTextPlate({ count: plate2?.count || 0, userType });

  const utm = `&cabmun_id=${id}`;

  const titleModal =
    userType === 'municipality'|| userType === 'citydistrict'
      ? 'Скопируйте сообщение и отправьте его школам муниципалитета'
      : 'Скопируйте сообщение и отправьте его муниципалитетам';

  return (
    <>
      <Main
        text="Соревнование «Академия функциональной грамотности» для&nbsp;учителей и учеников"
        isDone={isDone}
        items={[plate1?.status!, plate2?.status!, plate3?.status!, plate4?.status!]}
        background = 'linear-gradient(301.7deg, #C876FF 21.73%, #B0E0FF 94.19%)'
      >
        <Wrap>
          <MessagePlate
            status={plate2?.status!}
            number={'II'}
            messageTextToCopy={getTextMessageTwoModal(utm)}
            textPlate={textPlate2}
            titleModal={titleModal}
            nameButton={'Улучшить результат'}
            titlePlate={''}
            taskName="plate2"
          >
            <ContentTwoModal utm={utm} />
          </MessagePlate>
        </Wrap>
      </Main>
    </>
  );
};
